import React, { PureComponent, Fragment } from "react";

import { PieChart, Pie, Cell } from "recharts";

import { Metric, Error } from "./../../Utils/Utils.js";
import numeral from "../../../../node_modules/numeraljs/numeral.js";
import Heading from "../../Elements/Heading";

const COLORS = ["#f4f4f4", "#FAA461"];

class MinutesWatchedYesterday extends PureComponent {
  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <Fragment>
        <div className="row">
          <div className="col-12">
            <Heading
              size={6}
              className={"mb-1"}
              icons={data.minutes.yesterday_fb.networks}
              icons_size={"sm"}
            >
              Minutes Watched Yesterday
            </Heading>
            <Metric {...data.minutes.yesterday_fb} size={"lg"} />
          </div>

          <div className="col-12 mt-3 mb-3">
            <Heading
              size={6}
              className={"mb-1"}
              icons={data.minutes.two_days_ago.networks}
              icons_size={"sm"}
            >
              Minutes Watched 2 Days Ago
            </Heading>
            <Metric {...data.minutes.two_days_ago} size={"lg"} />
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-4">
            <Heading size={6} className={"mb-1"}>
              Last 7 Days
            </Heading>
            <Metric value={data.minutes.last7} size={"md"} />
          </div>
          <div className="col-4">
            <Heading size={6} className={"mb-1"}>
              Last 30 Days
            </Heading>
            <Metric value={data.minutes.last30} size={"md"} />
          </div>
          <div className="col-4">
            <Heading size={6} className={"mb-1"}>
              Year-To-Date
            </Heading>
            <Metric value={data.minutes.ytd} size={"md"} />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-12">
            <h6 className="widget__metric-label">
              <strong>Paid</strong> vs Organic Views
            </h6>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-6 col-sm-3">
            <h6 className="widget__metric-label">Last 7 Days</h6>

            <PieChart height={70} width={70}>
              <Pie
                dataKey="value"
                data={data.paid.last7}
                outerRadius="100%"
                innerRadius="70%"
              >
                {data.paid.last7.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__small"
              >
                {numeral(data.paid.last7[1].value).divide(100).format("%")}
              </text>
            </PieChart>
          </div>

          <div className="col-6 col-sm-3">
            <h6 className="widget__metric-label">Last 30 Days</h6>
            <PieChart height={70} width={70}>
              <Pie
                dataKey="value"
                data={data.paid.last30}
                outerRadius="100%"
                innerRadius="70%"
              >
                {data.paid.last30.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__small"
              >
                {numeral(data.paid.last30[1].value).divide(100).format("%")}
              </text>
            </PieChart>
          </div>

          <div className="col-6 col-sm-3">
            <h6 className="widget__metric-label">Year-To-Date</h6>
            <PieChart height={70} width={70}>
              <Pie
                dataKey="value"
                data={data.paid.ytd}
                outerRadius="100%"
                innerRadius="70%"
              >
                {data.paid.ytd.map((entry, index) => (
                  <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                ))}
              </Pie>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                className="piechart-metric__small"
              >
                {numeral(data.paid.ytd[1].value).divide(100).format("%")}
              </text>
            </PieChart>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default MinutesWatchedYesterday;
